import { Box, Icon } from '@chakra-ui/react';
import type { RegistrationVerificationState } from '@diamond/shared/features/registration/browser';

import { NOO_ICON_STROKE } from './NooRegistrationStatusConstants';

export function NooLogoGram() {
  return (
    <Box position="relative" w="38px" h="8" flexShrink={0} aria-hidden>
      <Box
        position="absolute"
        top="8px"
        left="0"
        w="4"
        h="4"
        borderRadius="full"
        bg="#EC161E"
      />
      <Box
        position="absolute"
        top="8px"
        left="11px"
        w="4"
        h="4"
        borderRadius="full"
        bg="#030181"
      />
      <Box
        position="absolute"
        top="8px"
        left="22px"
        w="4"
        h="4"
        borderRadius="full"
        bg="#01D1FF"
      />
    </Box>
  );
}

export function BellIcon() {
  return (
    <Icon viewBox="0 0 24 24" boxSize={6} color="#0941A8" aria-hidden>
      <path
        fill="currentColor"
        d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
      />
    </Icon>
  );
}

export function NooStatusDocsIcon() {
  return (
    <Icon viewBox="0 0 24 24" boxSize={6} aria-hidden>
      <path
        fill="none"
        stroke={NOO_ICON_STROKE}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7l-5-5Z"
      />
      <path
        fill="none"
        stroke={NOO_ICON_STROKE}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 2v6h6M10 9H8M16 13H8M16 17H8"
      />
    </Icon>
  );
}

export function NooStatusOutletIcon() {
  return (
    <Icon viewBox="0 0 24 24" boxSize={6} aria-hidden>
      <path
        fill="none"
        stroke={NOO_ICON_STROKE}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2 7 6.41 2.59A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"
      />
      <path
        fill="none"
        stroke={NOO_ICON_STROKE}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
      />
      <path
        fill="none"
        stroke={NOO_ICON_STROKE}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"
      />
      <path
        fill="none"
        stroke={NOO_ICON_STROKE}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2 7h20"
      />
      <path
        fill="none"
        stroke={NOO_ICON_STROKE}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M22 7v3a2 2 0 0 1-2 2 2 2 0 0 1-2-.37 2 2 0 0 1-2.41 0 2 2 0 0 1-2.59 0 2 2 0 0 1-2.41 0 2 2 0 0 1-2.59 0 2 2 0 0 1-2.41 0A2 2 0 0 1 4 12a2 2 0 0 1-2-2V7"
      />
    </Icon>
  );
}

export function SectionKindIcon({
  kind,
}: {
  kind: 'business' | 'documents' | 'outlet';
}) {
  if (kind === 'documents') {
    return <NooStatusDocsIcon />;
  }

  if (kind === 'outlet') {
    return <NooStatusOutletIcon />;
  }

  return <ShoppingBagIcon />;
}

export function ClockIcon() {
  return (
    <Icon viewBox="0 0 24 24" boxSize={6} aria-hidden>
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke="#E17100"
        strokeWidth="2"
      />
      <path
        fill="none"
        stroke="#E17100"
        strokeWidth="2"
        strokeLinecap="round"
        d="M12 6v6l4 2"
      />
    </Icon>
  );
}

export function SuccessHomeIcon() {
  return (
    <Icon viewBox="0 0 24 24" boxSize={6} aria-hidden>
      <path
        fill="#008236"
        d="M12 3.8 3.5 11.2a1 1 0 0 0-.5.86V20a1 1 0 0 0 1 1h4.5v-5.5h6V21H20a1 1 0 0 0 1-1v-7.94a1 1 0 0 0-.5-.86L12 3.8Z"
      />
    </Icon>
  );
}

export function ShoppingBagIcon({ color = NOO_ICON_STROKE }: { color?: string } = {}) {
  return (
    <Icon viewBox="0 0 24 24" boxSize={6} aria-hidden>
      <path
        fill={color}
        d="M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-8 0c0-1.1.9-2 2-2s2 .9 2 2h-4Z"
      />
    </Icon>
  );
}

export function CorrectionArrowIcon() {
  return (
    <Icon viewBox="0 0 24 24" boxSize={6} aria-hidden>
      <path
        fill="#C7C7CC"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14.5v-9l6 4.5-6 4.5z"
      />
    </Icon>
  );
}

function AlertCircleBadgeIcon({ color }: { color: string }) {
  return (
    <Icon viewBox="0 0 16 16" boxSize={4} aria-hidden>
      <circle
        cx="8"
        cy="8"
        r="6.665"
        fill="none"
        stroke={color}
        strokeWidth="1.33"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        d="M8 5v4.5"
      />
      <circle cx="8" cy="11.5" r="0.75" fill={color} />
    </Icon>
  );
}

function CheckCircleBadgeIcon({ color }: { color: string }) {
  return (
    <Icon viewBox="0 0 16 16" boxSize={4} aria-hidden>
      <circle
        cx="8"
        cy="8"
        r="6.665"
        fill="none"
        stroke={color}
        strokeWidth="1.33"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.5 8.2 7.5 10.2 10.8 6.5"
      />
    </Icon>
  );
}
export function StatusBadgeIcon({ state }: { state: RegistrationVerificationState }) {
  if (state === 'approved') {
    return <CheckCircleBadgeIcon color="#008236" />;
  }

  if (state === 'in_review') {
    return <AlertCircleBadgeIcon color="#0941A8" />;
  }

  if (state === 'correction') {
    return <AlertCircleBadgeIcon color="#BB4D00" />;
  }

  if (state === 'rejected') {
    return <AlertCircleBadgeIcon color="#EE0707" />;
  }

  if (state === 'pending') {
    return <AlertCircleBadgeIcon color="#637381" />;
  }

  return <AlertCircleBadgeIcon color="#BB4D00" />;
}
